import React from 'react';
import PageMeta from '../utils/PageMeta';
import ContentMap from './ContentMap';

const AllTopicsView = () => (
  <div id="content" className="no-padding-x no-padding-y">
    <PageMeta title="Content Map - Slab" />
    <ContentMap />
  </div>
);

export default AllTopicsView;
